import { render, staticRenderFns } from "./AddSystemArticle.vue?vue&type=template&id=30385aa5&scoped=true&"
import script from "./AddSystemArticle.vue?vue&type=script&lang=js&"
export * from "./AddSystemArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddSystemArticle.vue?vue&type=style&index=0&id=30385aa5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30385aa5",
  null
  
)

export default component.exports